module.exports = __webpack_public_path__ + "img/joint-store-bg.45197c17.png";